interface V3IconSingleLinkProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
    size?: number;
    strokeWidth?: string;
}

export const V3IconSingleLink = ({ stroke = "#2e77ff", size = 16, strokeWidth = "1.5" }: V3IconSingleLinkProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width={size} height={size} fill="none">
        <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} clipPath="url(#aV3IconSingleLink)">
            <path d="M6.667 9.333a2.333 2.333 0 0 0 3.333 0l2.666-2.667a2.357 2.357 0 0 0-3.333-3.333L9 3.666" />
            <path d="M9.333 6.667a2.333 2.333 0 0 0-3.333 0L3.333 9.334a2.357 2.357 0 1 0 3.334 3.333L7 12.334" />
        </g>
        <defs>
            <clipPath id="aV3IconSingleLink">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
);
